import React, { useState, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Modal from '@bitcoin-portal/bitcoincom-pkg-components/dist/Modal';
import QRCode from '@bitcoin-portal/bitcoincom-pkg-components/dist/QRCode';
import { handleRipple } from '../../../helpers/ripple';
import {
  StyledSection,
  StyledContentBlock,
  Icon,
  Title,
  Subtitle,
  Imagewrapper,
  Image,
  StyledButton,
  Contentwrapper,
  Textwrapper,
  Titlewrapper,
  MobileButton,
} from './styled';
import {
  QrCodeWrapper,
  StyledTitle,
  StyledSubtitle,
  ModalWrapper,
} from '../../../components/QrCodeModal/styled';

import StoreToggle from '../../../components/QrCodeModal/StoreToggle';

const Rewards = ({ template, mobileButtonLink }) => {
  const modalRef = useRef();
  const { messages, locale } = useIntl();
  const [selectedStore, setSelectedStore] = useState('GOOGLE_PLAY');

  const qrValue =
    selectedStore === 'GOOGLE_PLAY'
      ? messages['global.qrcodeModal.google-play.link']
      : messages['global.qrcodeModal.app-store.link'];

  return (
    <>
      <StyledSection>
        <StyledContentBlock>
          <Contentwrapper>
            <Icon
              src={messages[`${template}.rewards.icon.src`]}
              alt={messages[`${template}.rewards.icon.alt`]}
            />

            <Textwrapper>
              <Titlewrapper>
                <Title locale={locale}>
                  <FormattedMessage id={`${template}.rewards.title`} />
                </Title>
                <Subtitle>
                  <FormattedMessage id={`${template}.rewards.subtitle`} />
                </Subtitle>
                <StyledButton
                  onMouseEnter={handleRipple}
                  className="ga-rewards-cta get-rewards-cta-button"
                  onClick={() => modalRef.current.open()}
                >
                  <FormattedMessage id={`${template}.rewards.button`} />
                </StyledButton>
                <MobileButton
                  onMouseEnter={handleRipple}
                  href={mobileButtonLink}
                  target="_blank"
                >
                  <FormattedMessage id={`${template}.rewards.button`} />
                </MobileButton>
              </Titlewrapper>
            </Textwrapper>
          </Contentwrapper>
          <Imagewrapper>
            <Image
              src={messages[`${template}.rewards.image.src`]}
              alt={messages[`${template}.rewards.image.alt`]}
            />
          </Imagewrapper>
        </StyledContentBlock>
      </StyledSection>
      <ModalWrapper>
        <Modal ref={modalRef}>
          <StyledTitle>{messages['global.qrcodeModal.title']}</StyledTitle>
          <StyledSubtitle>
            {messages['global.qrcodeModal.description']}
          </StyledSubtitle>
          <StoreToggle
            selectedStore={selectedStore}
            setSelectedStore={setSelectedStore}
          />
          <QrCodeWrapper>
            <QRCode value={qrValue} />
          </QrCodeWrapper>
        </Modal>
      </ModalWrapper>
    </>
  );
};

Rewards.propTypes = {
  template: PropTypes.string.isRequired,
  mobileButtonLink: PropTypes.string.isRequired,
};

export default Rewards;
